import { Directive, OnDestroy, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RPCResult } from '@campaign-portal/namespace/common/rpc.response';
import { BehaviorSubject, Observable } from 'rxjs';

import { ensureDialogCaller } from '../utils';
import { CanDeactivateComponent } from './can-deactivate.component';

@Directive()
export abstract class BaseActionDialogComponent extends CanDeactivateComponent implements OnDestroy {
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly allowedDeactivation = signal(true);

	protected runAction<T>(
		caller$: Observable<RPCResult<T>> | null | undefined,
		onResult: (resp: RPCResult<T>) => void
	): void {
		this.loading$.next(true);
		this.allowedDeactivation.set(false);

		ensureDialogCaller(caller$)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe({
				next: (resp) => {
					this.allowedDeactivation.set(true);
					this.loading$.next(false);
					onResult(resp);
				},
				error: () => {
					this.allowedDeactivation.set(true);
					this.loading$.next(false);
				},
			});
	}

	ngOnDestroy(): void {
		this.loading$.complete();
	}
}
